/* unplugin-vue-components disabled */import script from "./addBusinessDailog.vue?vue&type=script&setup=true&lang=js"
export * from "./addBusinessDailog.vue?vue&type=script&setup=true&lang=js"

import "./addBusinessDailog.vue?vue&type=style&index=0&id=2ace160b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ace160b"]])

export default __exports__